var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mt-5",attrs:{"width":"500px"}},[_c('v-card-title',[_c('div',{staticClass:"notfound"},[_vm._v("このページは存在しません")])]),_c('v-card-text',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("TOPへ戻る")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }